import { IconProps, iconColor } from './IconProps'

export function ChartPieIcon(props: IconProps) {
  const size = props.size || 24

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM11 4.06152C7.05369 4.55362 4 7.92038 4 12C4 16.4183 7.58172 20 12 20C13.7339 20 15.3391 19.4481 16.6494 18.5107L11.2656 12.6787C11.0951 12.494 11 12.2514 11 12V4.06152ZM18.1182 17.1543C19.0896 16.0022 19.7425 14.5719 19.9385 13H14.2842L18.1182 17.1543ZM13 11H19.9385C19.4872 7.38128 16.6187 4.51277 13 4.06152V11Z'
        fill={iconColor(props)}
      />
    </svg>
  )
}
